import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  useCartDeleteMutation,
  useGetCartProductsQuery,
  useGetTotalCartQuery,
  useUpdateCartQtyMutation,
} from "../redux/feature/slice/service-api";
import { FaRegTrashAlt } from "react-icons/fa";
import Title from "../components/helmet/title";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';

const ViewCart = () => {
  const [ip, setIp] = useState();

  useEffect(() => {
    window.scrollTo(0, 0);

    const fetchIpAddress = async () => {
      try {
        const response = await axios.get("https://api.ipify.org?format=json");
        setIp(response.data.ip);
      } catch (error) {
        console.error("Error fetching IP address:", error);
        setIp("127.0.0.1");
      }
    };
    fetchIpAddress();
  }, []);

  const { data, refetch: refetchCart } = useGetCartProductsQuery(ip);
  const { refetch } = useGetTotalCartQuery(ip);
  const [deleteCart] = useCartDeleteMutation();
  const [updateCart] = useUpdateCartQtyMutation();

  useEffect(() => {
    if (data?.data?.carts && Array.isArray(data.data.carts)) {
      const items = data.data.carts.map(cartItem => ({
        item_name: cartItem.product.name,
        item_id: cartItem.product.id,
        price: cartItem.product.discount_price || cartItem.product.regular_price,
        item_brand: "Unknown",
        item_category: cartItem.product.category.name,
        quantity: cartItem.qty,
      }));

      const total_price = data.data.carts.reduce(
        (sum, cartItem) => sum + (cartItem.price * cartItem.qty),
        0
      );

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ ecommerce: null });
      window.dataLayer.push({
        event: "view_cart",
        ecommerce: {
          currency: "BDT",
          value: total_price,
          items: items,
        },
      });
    }
  }, [data]);

  const deleteHandler = async (id) => {
    try {
      const res = await deleteCart(id).unwrap();
      toast.success(res?.message || "Product deleted from cart");
      refetchCart();
      refetch();
    } catch (error) {
      toast.error("Error deleting product");
    }
  };

  const handleQtyChange = async (id, currentQty, type) => {
    const newQty = type === 'inc' ? currentQty + 1 : currentQty - 1;

    if (newQty < 1) return toast.warning("Minimum quantity is 1");

    try {
      await updateCart({ id, qty: newQty }).unwrap();
      toast.success("Quantity updated successfully");
      refetchCart();
      refetch();
    } catch (error) {
      toast.error("Failed to update quantity");
    }
  };

  return (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <section className="container mx-auto px-2 lg:px-20 my-10 mt-14 md:mt-10">
        <Title title={"View cart"} content={"This is view cart page"} />
        <div>
          <button className="px-4 py-4 bg-primary text-white rounded-md hover:bg-green-700">
            <Link to="/">Continue Shopping</Link>
          </button>
        </div>
        <div>
          <div className="relative overflow-x-auto mt-10">
            <table className="w-full text-sm text-left rtl:text-right text-base_500">
              <thead className="text-md text-base_700 uppercase bg-base">
                <tr>
                  <th className="px-4 py-4">Image</th>
                  <th className="py-4">Product Name</th>
                  <th className="p-4">Price</th>
                  <th className="px-4 py-4">Quantity</th>
                  <th className="p-4">Total</th>
                  <th className="p-2">Remove</th>
                </tr>
              </thead>
              <tbody>
                {data?.data?.carts?.length > 0 ? (
                  data.data.carts.map((cProduct) => (
                    <tr key={cProduct.id} className="text-black border-b bg-base_300">
                      <td className="px-4 py-2">
                        <img
                          src={cProduct?.product?.imageUrl}
                          alt=""
                          className="w-20 h-20"
                        />
                      </td>
                      <td className="p-2 font-medium text-md w-44 lg:w-96">
                        {cProduct?.product?.name}
                      </td>
                      <td className="px-4 py-2 font-medium whitespace-nowrap text-md">
                        {cProduct?.price}
                      </td>
                      <td className="font-medium whitespace-nowrap">
                        <div className="flex items-center gap-2">
                          <button
                            onClick={() => handleQtyChange(cProduct?.id, cProduct?.qty, 'dec')}
                            className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                          >
                            -
                          </button>
                          <span className="w-8 text-center">{cProduct?.qty}</span>
                          <button
                            onClick={() => handleQtyChange(cProduct?.id, cProduct?.qty, 'inc')}
                            className="px-2 py-1 bg-gray-200 rounded hover:bg-gray-300"
                          >
                            +
                          </button>
                        </div>
                      </td>
                      <td className="px-4 py-2 font-medium whitespace-nowrap text-md">
                        {cProduct?.price * cProduct?.qty}
                      </td>
                      <td className="px-6 py-2 text-center">
                        <button
                          onClick={() => deleteHandler(cProduct?.id)}
                          className="text-primary active:text-danger"
                        >
                          <FaRegTrashAlt />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-10">
                      There are no products in the cart.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="text-center my-8">
            <button className="bg-primary rounded-md px-8 py-4 text-white">
              <Link to="/checkout">
                Proceed to checkout
                <i className="fa-solid fa-right-from-bracket ml-2"></i>
              </Link>
            </button>
          </div>
        </div>
      </section>
    </>
  );
};

export default ViewCart;
